import { makeStyles as makeStylesOriginal, Theme } from '@material-ui/core';
import { ClassNameMap, Styles, WithStylesOptions } from '@material-ui/styles/withStyles';

const makeThemedStyles = (style: Styles<Theme, {}, string>, options?: Omit<WithStylesOptions<Theme>, 'withTheme'>): ((props?: any) => ClassNameMap<string>) => makeStylesOriginal(style, options);

export default makeThemedStyles;
